<template>
    <div class="card-container">
        <el-row class="flow-wrap" :gutter="25">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
                <div class="grid-content">
                    <el-card class="box-card">
                        <div>
                            <p class="title">平台总收入(元)</p>
                            <h1 class="num2">￥{{toDoubleThousands(cardData.incomeTotalAcct *100 / 10000) || 0}}</h1>
                        </div>
                    </el-card>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
                <div class="grid-content">
                    <el-card class="box-card">
                        <div>
                            <p class="title">平台可提现收入(元)</p>
                            <div class="flex-row vertical-center flow-justify">
                                <h1 class="num2">￥{{toDoubleThousands(cardData.cashAcct *100 / 10000) || 0}}</h1>
                                <el-button type="primary" class="button-size" @click="handleChange(0)" v-if="hasPerm('/withdraw/applyWithDraw')">提现</el-button>
                            </div>
                        </div>
                    </el-card>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
                <div class="grid-content">
                    <el-card class="box-card">
                        <div>
                            <p class="title">服务费余额(元)</p>
                            <h1 class="num2">￥{{toDoubleThousands(cardData.outcomeAcct *100 / 10000) || 0}}</h1>
                        </div>
                    </el-card>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8"  v-if="hasPerm('/withdraw/applyWithDraw')">
                <div class="grid-content">
                    <el-card class="box-card">
                        <div>
                            <p class="title">提现账户信息</p>
                            <div class="flex-row vertical-center flow-justify">
                                <div class="msg">
                                    <p>手机号：{{info.phoneNumber || '未设置'}} </p>
                                    <p>姓名：{{info.realName || '未设置'}}</p>
                                    <p>银行卡号：{{doUnicode(info.bankCard) || '未设置'}}</p>
                                </div>
                                <el-button type="primary" class="button-size" @click="handleChange(1)">设置</el-button>
                            </div>
                        </div>
                    </el-card>
                </div>
            </el-col>
        </el-row>
        <form-dialog ref="formDialog" :formDialogTitle="formDialogTitle" :model="dialogModel"
                     :submitData="dialogData" :rules="dialogRules" :dialogService="dialogService"
                     @success="dialogSuccess" @close="dialogClose" @opend="dialogOpen" class="over" labelWidth="100px">
            <div v-if="dialogType == 0">
                <el-form-item label="提现" prop="amount">
                    <div class="flex-row">
                        <el-input-number v-model="dialogModel.amount" controls-position="right" :precision="2" :step="0.1" :controls="false"
                                         :min="0" style="width: 280px"></el-input-number>
                        <span class="formSpan">元</span>
                    </div>
                </el-form-item>
            </div>
            <div v-else>
                <el-form-item label="手机号" prop="phoneNumber">
                    <el-input type="text" maxlength="11" show-word-limit v-model="dialogModel.phoneNumber" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="realName">
                    <el-input type="text" maxlength="20" show-word-limit v-model="dialogModel.realName" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="银行卡号" prop="bankCard">
                    <el-input type="text" maxlength="25" show-word-limit v-model="dialogModel.bankCard" placeholder="请输入银行卡号"></el-input>
                </el-form-item>
            </div>
        </form-dialog>
    </div>
</template>

<script>
    import FormDialog from '../../dialog/FormDialog'

    import FinanceService from 'service/FinanceService'
    import OrganService from 'service/OrganService'
    import privateKey from 'service/constant/privateKey';
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "PlatformAssets",
        components:{
            FormDialog
        },
        data(){
            return{
                dialogModel:{
                    amount:'',
                    phoneNumber:'',
                    realName:'',
                    bankCard:'',
                },
                dialogType:'1',
                formDialogTitle:'',
                dialogRules:{
                    amount: [{
                        required: this.dialogType == 0,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请输入提现金额'))
                            } else if (value > this.cardData.cashAcct *100 / 10000) {
                                callback(new Error('输入金额超过可提现金额'))
                            } else {
                                callback()
                            }
                        },
                    }],
                    phoneNumber: [{
                        required: this.isSet,
                        validator: this.validPhone,
                    }],
                    realName: [{
                        required: this.isSet,
                        message:'请输入姓名',
                    }],
                    bankCard: [{
                        required: this.isSet,
                        message:'请输入银行卡号'
                    }],
                },
                cardData:{},
                info:{},
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        computed:{
            submitData(){
                const params = {
                    userId: this.userId,
                    tatSimpleId: this.tatId,
                };
                return params;
            },
            dialogData(){
                const params = {
                    tatUserId: this.userId,
                };
                if (this.dialogType == 0) {
                    params.roleType = 0;
                    // params.memId = this.userId;
                    params.amount = this.dialogModel.amount;
                } else {
                    params.realName = this.dialogModel.realName;
                    params.bankCard = this.dialogModel.bankCard;
                    params.phoneNumber = this.dialogModel.phoneNumber;
                }
                return params;
            },
            dialogService(){
                if (this.dialogType == 0) {
                    return FinanceService.applyWithDraw;
                } else {
                    return FinanceService.addTatAccountInfo;
                }
            },
            ...mapGetters(['serverType', 'tatId', 'userId']),
        },
        mounted(){
            this.getList();
            this.getAcctInfo();
        },
        methods:{
            getList() {
                this.doLoad(FinanceService.getTatAssets, this.submitData, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        // console.log('result',result.rows)
                        this.cardData = result.rows[0]
                    });
                }, '信息获取失败')
            },
            getAcctInfo(){
                this.doLoad(FinanceService.getAcctInfo, this.submitData, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        // console.log('getAcctInfo',result);
                        this.info = result;
                    });
                }, '信息获取失败');
            },
            dialogSuccess(res){
                this.doCheck(res,res =>{
                    this.showSuccess(res.respMsg);
                    this.$refs.formDialog.closeDialog();
                    this.getList();
                    this.getAcctInfo();
                });
            },
            dialogClose(){},
            dialogOpen(){

            },
            handleChange(type){
                this.formDialogTitle = type == 0 ? '提现' : '提现账户信息'
                this.dialogType = type;
                this.$refs.formDialog.open();
            },
            isSet(){
                return this.dialogType == 1;
            }
        }
    }
</script>

<style scoped>
    .el-row, .grid-content, .el-card{
        height: 100%;
    }
    .el-col{
        margin-bottom: 30px;
    }
    .title{
        font-size: 14px;
        color: #666666;
    }
    .num{
        font-size: 40px;
        color: #000000;
        border-bottom: 1px solid #E6E6E6;
        padding: 20px 0;
        margin-bottom: 20px;
    }
    .num2{
        font-size: 40px;
        color: #000000;
    }
    .msg p{
        color: #000000;
        font-size: 16px;
        font-weight: 400;
        line-height: 26px;
    }
    .msg p:first-child{
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/PlatformAssets.vue